<nav class="navbar navbar-expand-lg navbar navbar-dark bg-dark ">
    <i class="fas fa-dumbbell fa-2x"></i>
    <a class="navbar-brand" href="#">Fit ME</a>
    <button class="navbar-toggler" type="button" (click)="toggleNavbar()" data-toggle="collapse"
        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
        aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngClass]="{'show':navbarOpen}">
        <ul class="navbar-nav ml-auto">
            <li class="nav-item active">
                <a routerLink="/home" class="nav-link">Home </a>
            </li>
            <li class="nav-item">
                <a routerLink="/about" class="nav-link">About</a>
            </li>
            <li class="nav-item">
                <a routerLink="/contact" class="nav-link">Contact US</a>
            </li>
        </ul>

    </div>
</nav>



<router-outlet></router-outlet>

<footer id="main-footer">
    <h3>Mandar Priyanka Kale</h3>
    <p><a href="https://www.linkedin.com/in/mandarkale5/" target="_blank">LinkedIn</a> | <i class="fas fa-envelope fa-1x"></i>
      mandarkale@gmail.com
    </p>
    <p>Fit ME &copy; 2020, All rights reserved</p>

  </footer> 